import url from '../url'
import headers from '../headers'

export default {
	getAllByWatch (context, user_uid, watch_id, offset = 0, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/chat/watch?offset=${offset}&size=${size}`,
			headers.bearer()
		)
	},
	getAllByUser (context, user_uid, watch_id, offset = 0, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/chat/user?offset=${offset}&size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/chat/${id}`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/chat`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/chat/${model.id}`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/chat.js